export const REQUEST_ALL_VENUES = 'app/venues/REQUEST_ALL_VENUES';
export const REQUEST_ALL_VENUES_SUCCESS = 'app/venues/REQUEST_ALL_VENUES_SUCCESS';
export const REQUEST_ALL_VENUES_FAILURE = 'app/venues/REQUEST_ALL_VENUES_FAILURE';
